import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { Observable, combineLatest } from "rxjs";
import { filter, map } from "rxjs/operators";
import { AuthenticationService, LoginState } from "./authentication.service";
import { LogCategory, LogCoreService, LogType, LoggerService } from "./logger.service";
import { ProfileService } from "./profile.service";


@Injectable({
    providedIn: 'root'
})
class PageGuardService {
    path: ActivatedRouteSnapshot[];
    route: ActivatedRouteSnapshot;

    constructor(
        private profileService: ProfileService,
        private authService: AuthenticationService,
        private logger: LoggerService,
        private router: Router
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.CoreService, LogCoreService.PageGuard, category);
    }

    // Determines whether or not a user is allowed to activate the route
    canActivate(route: ActivatedRouteSnapshot) {
        this.log("canactivate", null, LogCategory.Default);
        //If a user is logged out or expired then return false (cannot activate)
        //If a user is any other login state then check for the profile, ignore null profile because we assume that they are in process of getting profile

        const filteredProfile$ = this.profileService.profile$.pipe(
            filter((profile) => !!profile ), //filters out null profiles, forces this to wait for an actual profile as the user is not logged out            
        )

        return combineLatest(this.authService.loginState$, filteredProfile$ )
            .pipe(
            map(([loginState, profile]) => {
                if (loginState <= LoginState.loggedout && loginState >= LoginState.expired) //if the user is logged out or expired always return false                
                    return false;
                else {
                    var canRoute = profile.version < 2
                        ? !!this.profileService.pageStore[route.data.Page]
                        : !!this.profileService.componentStore[route.data.Page];

                    if (!canRoute)
                        this.router.navigate(['/dashboard']);

                    return canRoute   
                }  
              })
            )
    }
 
}

export const PageGuard: CanActivateFn = (next: ActivatedRouteSnapshot): Observable<boolean> => {
    return inject(PageGuardService).canActivate(next);
}


export enum PageType {
    Catalog = "Catalog",
    Courses = "Courses",
    Careers = "Careers",
    People = "People",
    Facilities = "Facilities",
    FacilitiesEvents = "EventsForm",
    ParkingEvents = "ParkingForm",
    FacilitiesIssue = "IssueForm",
    Resources = "Resources",
    Search = "Search",
    StyleGuide = "StyleGuide",
    Social = "Social",
    Tiles = "Tiles",
}
